(() => {
  const hiddenAttribute = 'data-coeur-stay-teaser-hidden';
  const forceBlackAttribute = 'data-coeur-force-black';

  const normalize = (value) => value.replace(/\s+/g, ' ').trim().toUpperCase();

  const isStayTeaserStep = (step) => {
    const text = normalize(step.innerText || step.textContent || '');

    return text.startsWith('STAY IN TOUCH') && !text.includes('STAY CONNECTED');
  };

  const isMenuOpen = () => !!document.querySelector('.section-header.menu-open');

  const isCartDrawerOpen = () => !!document.querySelector('cart-drawer.active');

  const isAtLandingTop = () => {
    if (!document.body.classList.contains('template-index')) return false;

    const landing = document.querySelector('.coeur-home-landing');
    if (!landing) return false;

    if (isCartDrawerOpen()) return false;

    return window.scrollY <= 8;
  };

  const setWrapperHidden = (wrapper, shouldHide) => {
    if (shouldHide) {
      wrapper.setAttribute(hiddenAttribute, 'true');
      wrapper.style.setProperty('display', 'none', 'important');
      return;
    }

    if (wrapper.hasAttribute(hiddenAttribute)) {
      wrapper.removeAttribute(hiddenAttribute);
      wrapper.style.removeProperty('display');
    }
  };

  // The teaser's text is styled inside Mailchimp's own shadow DOM, so a
  // light-DOM stylesheet can't reach it. Instead we inject one small
  // stylesheet into the shadow root itself (once) and flip a host attribute
  // to force black text while the hamburger drawer's light background is
  // behind it — otherwise the default white text reads as washed out.
  const injectForceBlackStyle = (root) => {
    if (root.getElementById('coeur-stay-teaser-force-black')) return;

    const style = document.createElement('style');
    style.id = 'coeur-stay-teaser-force-black';
    style.textContent = `
      :host([${forceBlackAttribute}="true"]) .step.visible,
      :host([${forceBlackAttribute}="true"]) .step.visible * {
        color: #000 !important;
      }
    `;
    root.appendChild(style);
  };

  const setWrapperForcedBlack = (wrapper, shouldForce) => {
    if (shouldForce) {
      wrapper.setAttribute(forceBlackAttribute, 'true');
      return;
    }

    wrapper.removeAttribute(forceBlackAttribute);
  };

  // Line the teaser's text up with the left edge of the hamburger icon. The
  // icon's position depends on viewport width, so measure it rather than
  // hard-coding an offset. Mailchimp positions the teaser with a fixed-position
  // box whose text sits inset by the button's padding, so shift the box by
  // the difference between the text's left edge and the icon's.
  let lastMenuIconLeft = null;
  // The text ends in ~22px of trailing whitespace, so this trims ~24px of underline.
  const stayTeaserRightCrop = 'inset(0 46px 0 0)';

  const alignStayTeaser = (step) => {
    const icon = document.querySelector('.header--coeur .header__icon--menu .icon-coeur-menu');
    const iconRect = icon && icon.getBoundingClientRect();
    if (iconRect && iconRect.width > 0) lastMenuIconLeft = iconRect.left;
    if (lastMenuIconLeft === null) return;

    const box = Array.from(step.querySelectorAll('*')).find(
      (el) => window.getComputedStyle(el).position === 'fixed'
    );
    if (!box) return;

    const textEl = Array.from(box.querySelectorAll('*')).find(
      (el) => el.children.length === 0 && el.textContent.trim().length > 0
    );
    if (!textEl) return;

    // Hidden (display: none) boxes measure as zero; wait until it's shown.
    const boxRect = box.getBoundingClientRect();
    if (boxRect.width === 0) return;

    const textInset = textEl.getBoundingClientRect().left - boxRect.left;
    const targetLeft = `${Math.round(lastMenuIconLeft - textInset)}px`;

    // Only write when it changes: the shadow-root observer watches attributes,
    // so an unconditional write would retrigger this sync indefinitely.
    if (box.style.getPropertyValue('left') !== targetLeft) {
      box.style.setProperty('left', targetLeft, 'important');
    }

    // Shorten the trailing underline a little by clipping the text's right end.
    if (textEl.style.getPropertyValue('clip-path') !== stayTeaserRightCrop) {
      textEl.style.setProperty('clip-path', stayTeaserRightCrop, 'important');
    }
  };

  const syncStayTeaserVisibility = () => {
    document.querySelectorAll('[id^="mcforms-"]').forEach((wrapper) => {
      try {
        const root = wrapper.shadowRoot;
        if (!root) return;

        injectForceBlackStyle(root);

        const visibleSteps = Array.from(root.querySelectorAll('.step')).filter(
          (step) => window.getComputedStyle(step).display !== 'none'
        );
        const stayTeaserStep = visibleSteps.find(isStayTeaserStep);

        if (!stayTeaserStep) {
          setWrapperHidden(wrapper, false);
          setWrapperForcedBlack(wrapper, false);
          return;
        }

        setWrapperHidden(wrapper, !isAtLandingTop());
        setWrapperForcedBlack(wrapper, isMenuOpen());
        alignStayTeaser(stayTeaserStep);
      } catch (error) {
        console.error('[coeur-mailchimp-stay-teaser]', error);
      }
    });
  };

  const observeMailchimpWrappers = () => {
    document.querySelectorAll('[id^="mcforms-"]').forEach((wrapper) => {
      try {
        if (wrapper.dataset.coeurStayTeaserObserved === 'true' || !wrapper.shadowRoot) return;

        wrapper.dataset.coeurStayTeaserObserved = 'true';
        new MutationObserver(syncStayTeaserVisibility).observe(wrapper.shadowRoot, {
          attributes: true,
          childList: true,
          subtree: true,
        });
      } catch (error) {
        console.error('[coeur-mailchimp-stay-teaser]', error);
      }
    });
  };

  const sync = () => {
    observeMailchimpWrappers();
    syncStayTeaserVisibility();
  };

  new MutationObserver(sync).observe(document.documentElement, {
    childList: true,
    subtree: true,
    attributes: true,
    attributeFilter: ['class'],
  });

  window.addEventListener('scroll', syncStayTeaserVisibility, { passive: true });
  window.addEventListener('resize', syncStayTeaserVisibility);
  document.addEventListener('DOMContentLoaded', sync);
  sync();
})();
